import React from 'react';
import { t } from 'ttag';
import MuiPhoneNumber from 'material-ui-phone-number';
import { useFormikContext } from 'formik';
import { makeStyles } from '@material-ui/core';
import { Select } from '@coolremote/shared';
import { AuthForm, AuthField } from '../../../UnifiedComponents';
import { createValidationSchema } from '../../validationSchemas';

const useStyles = makeStyles(() => ({
  selectLabel: {
    color: '#ffffff !important',
  },
  select: {
    margin:0,
    '& .Select_trigger__jFZij': {
      height:53,
      borderRadius: 12,
      background: 'transparent !important',
      color: '#fff !important',
      borderColor: '#ffffff38 !important',
      '&:hover':{
        borderColor: '#fff !important'
      }
    },
     '& .select-arrow-icon': {
        fill: '#fff !important',
      },
  },
}));

const NewUserFormFields = ({ theme, inviteInfo, lists }) => {
  const classes = useStyles();
  const { values, setFieldValue } = useFormikContext();

  const getPhoneFieldStyles = () => ({
    width: '100%',
    '& .MuiOutlinedInput-root': {
      color: theme === 'dark' ? '#ffffff' : '#333333',
      '& fieldset': {
        borderColor: theme === 'dark' ? '#555555' : '#cccccc',
      },
      '&:hover fieldset': {
        borderColor: theme === 'dark' ? '#777777' : '#999999',
      },
      '&.Mui-focused fieldset': {
        borderColor: theme === 'dark' ? '#ffffff' : '#1976d2',
      },
    },
    '& .MuiInputLabel-root': {
      color: theme === 'dark' ? '#cccccc' : '#666666',
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: theme === 'dark' ? '#ffffff' : '#1976d2',
    },
  });

  return (
    <>
      {/* First Name Field */}
      <AuthField
        theme={theme}
        label={t`First Name`}
        name="firstName"
        required
        maxLength={20}
      />

      {/* Last Name Field */}
      <AuthField theme={theme} label={t`Last Name`} name="lastName" required maxLength={20} />

      {/* Email Field */}
      <AuthField
        theme={theme}
        label={t`Email`}
        name="email"
        type="email"
        required
        disabled
      />

      {/* Subscription Code Field - only show if required */}
      {inviteInfo?.setSubscription && (
        <AuthField
          theme={theme}
          label={t`Subscription Code`}
          name="subscriptionCode"
          required
        />
      )}

      {/* Phone Number Field */}
      <div style={{ marginBottom: '16px' }}>
        <MuiPhoneNumber
          defaultCountry={'us'}
          placeholder="Enter Phone Number"
          label="Enter Phone Number"
          disableAreaCodes={true}
          variant="outlined"
          style={getPhoneFieldStyles()}
        />
      </div>

      {/* Temperature Scale Field */}
      <Select
        label={t`Temperature Units`}
        value={values.temperatureScale}
        onChange={(val) => setFieldValue('temperatureScale', val)}
        options={lists?.temperatureScaleOptions}
        fullWidth
        className={classes.select}
        classes={{ label: classes.selectLabel }}
      />

      {/* Time Format Field */}
      <Select
        label={t`Time Format`}
        value={values.timeFormat}
        onChange={(val) => setFieldValue('timeFormat', val)}
        options={lists?.timeFormatOptions}
        fullWidth
        className={classes.select}
        classes={{ label: classes.selectLabel }}
      />

      {/* Date Format Field */}
      <Select
        label={t`Date Format`}
        value={values.dateFormat}
        onChange={(val) => setFieldValue('dateFormat', val)}
        options={lists?.dateFormatOptions}
        fullWidth
        className={classes.select}
        style={{ marginBottom: '16px' }}
        classes={{ label: classes.selectLabel }}
      />

      {/* Password Field */}
      <AuthField
        theme={theme}
        label={t`Password`}
        name="password"
        type="password"
        required
      />

      {/* Confirm Password Field */}
      <AuthField
        theme={theme}
        label={t`Confirm Password`}
        name="confirmPassword"
        type="password"
        required
      />
    </>
  );
};

const NewUserForm = ({
  theme,
  inviteInfo,
  initialValues,
  onSubmit,
  isSubmitting,
  lists,
}) => {
  return (
    <AuthForm
      theme={theme}
      initialValues={initialValues}
      validationSchema={createValidationSchema(inviteInfo)}
      onSubmit={onSubmit}
      submitButtonText={
        isSubmitting ? t`Creating Account...` : t`Create Account`
      }
      isSubmitting={isSubmitting}
    >
      <NewUserFormFields theme={theme} inviteInfo={inviteInfo} lists={lists} />
    </AuthForm>
  );
};

export { NewUserForm };
